// extracted by mini-css-extract-plugin
export default {"App":"RulesPassword_App__6kWN+","rules_password":"RulesPassword_rules_password__PrFHT","title_rules":"RulesPassword_title_rules__4ssWM"};